import { useEffect } from 'react';
import { AccountRequestStatus } from '@common/enums/accountRequestStatus';
import { useAccountRequestContext } from '@frontend/utils/hooks/useAccountRequestContext';
import { AccountRequestApprovedView } from './AccountRequestApprovedView';
import { AccountRequestDeniedView } from './AccountRequestDeniedView';
import { AccountRequestRejectingView } from './AccountRequestRejectingView';
import { AccountRequestReviewingView } from './AccountRequestReviewingView';
import { AccountRequestWrongApproverView } from './AccountRequestWrongApproverView';

export enum AccountRequestReviewByOrganizationView {
    reviewingRequest,
    requestApproved,
    rejectingRequest,
    requestDenied,
    wrongApprover,
}

interface AccountRequestApprovalViewsProps {
    currentView: AccountRequestReviewByOrganizationView;
    handleViewChange: (newView: AccountRequestReviewByOrganizationView) => void;
}

export function AccountRequestReviewByOrganizationViews(props: Readonly<AccountRequestApprovalViewsProps>) {
    const { accountRequest, hasReviewAuthorizationError } = useAccountRequestContext();

    useEffect(() => {
        if (hasReviewAuthorizationError) {
            props.handleViewChange(AccountRequestReviewByOrganizationView.wrongApprover);
        } else if (accountRequest.status) {
            props.handleViewChange(getInitialView(accountRequest.status));
        }
    }, [accountRequest.status, hasReviewAuthorizationError]);

    if (props.currentView === AccountRequestReviewByOrganizationView.reviewingRequest) {
        return <AccountRequestReviewingView handleViewChange={props.handleViewChange} />;
    } else if (props.currentView === AccountRequestReviewByOrganizationView.requestApproved) {
        return <AccountRequestApprovedView />;
    } else if (props.currentView === AccountRequestReviewByOrganizationView.rejectingRequest) {
        return <AccountRequestRejectingView handleViewChange={props.handleViewChange} />;
    } else if (props.currentView === AccountRequestReviewByOrganizationView.requestDenied) {
        return <AccountRequestDeniedView />;
    } else if (props.currentView === AccountRequestReviewByOrganizationView.wrongApprover) {
        return <AccountRequestWrongApproverView />;
    }

    function getInitialView(accountRequestStatus: AccountRequestStatus) {
        if (accountRequestStatus === AccountRequestStatus.pending) {
            return AccountRequestReviewByOrganizationView.reviewingRequest;
        } else if (accountRequestStatus === AccountRequestStatus.approved) {
            return AccountRequestReviewByOrganizationView.requestApproved;
        } else if (accountRequestStatus === AccountRequestStatus.rejected) {
            return AccountRequestReviewByOrganizationView.requestDenied;
        } else {
            return AccountRequestReviewByOrganizationView.reviewingRequest;
        }
    }
}
